import React, { useState, useEffect, useRef } from "react";
import GameInfoBox from "../GameInfoBox/GameInfoBox";
import './Main.css';

function Main() {
    const data =[
        {
            title: 'Type 11',
            images4urls: ['','','',''],
            platform: 'VR',
            description: 'An interactive demo of a Type 11 shuttlecraft in VR.',
            downloadUrl: 'https://www.oculus.com/experiences/quest/5233088956719525/'
        }, {
            title: 'Final Frontier',
            images4urls: ['','','',''],
            platform: 'Android',
            description: 'A space-combat simulation game.',
            downloadUrl: 'https://play.google.com/store/apps/details?id=kfireven.finalfrontier'
        }, {
            title: 'Final Frontier DEMO',
            images4urls: ['','','',''],
            platform: 'Android',
            description: 'Demo of Final Frontier.',
            downloadUrl: 'https://play.google.com/store/apps/details?id=far.beyond.the.stars'
        }, {
            title: 'Spaceships vs. Asteroids',
            images4urls: ['','','',''],
            platform: 'Android',
            description: 'Survive waves of asteroids.',
            downloadUrl: 'https://play.google.com/store/apps/details?id=spaceships.vs.asteroids'
        }, {
            title: 'Asteroid Field‏',
            images4urls: ['','','',''],
            platform: 'Android',
            description: 'Blast your way through an asteroid field.',
            downloadUrl: 'https://play.google.com/store/apps/details?id=com.asteroidfield'
        }, {
            title: 'Invaders 2K Multiplayer',
            images4urls: ['','','',''],
            platform: 'Android',
            description: 'Fight against waves of alien invaders from space.',
            downloadUrl: 'https://play.google.com/store/apps/details?id=com.Invaders2K'
        }, {
            title: 'To Do',
            images4urls: ['','','',''],
            platform: 'Android',
            description: 'With this app you can manage a list of tasks to do.',
            downloadUrl: 'https://play.google.com/store/apps/details?id=il.ac.hit.todo2'
        }
    ]

    return(
        <div className="Main">
            <div className="header">
                <div className="subheader">
                    <div style={{display: 'flex', justifyContent: 'space-between'}}>
                        <div className="title-big">Kfir</div>
                        <div className="title-big">Even</div>
                    </div>
                    <div className="title-small">Apps &nbsp; & &nbsp; Games</div>
                </div>
                <div className="subheader">
                    <div style={{display: 'flex', whiteSpace: 'nowrap'}}>
                        <div style={{display: 'inline'}}>
                            <img src="imgs/1.png" width="15px" height="12px" className="link"  onClick={() => document.location = 'mailto:kfireven@gmail.com'}/>
                        </div>
                        <div className="link" style={{display: 'flex', whiteSpace: 'nowrap'}} onClick={() => document.location = 'mailto:kfireven@gmail.com'}>&nbsp; E-Mail</div>
                    </div>

                    <div style={{display: 'flex', whiteSpace: 'nowrap'}}>
                        <div style={{display: 'inline'}}>
                            <img src="imgs/3.png" width="15px" height="14px" className="link"  onClick={() => document.location = 'mailto:kfireven@gmail.com'}/>
                        </div>
                        <a href="https://www.linkedin.com/in/kfireven/" target="_blank" style={{display: 'flex', whiteSpace: 'nowrap'}}>&nbsp; Linkedin</a>
                    </div>

                    <div style={{display: 'flex', whiteSpace: 'nowrap'}}>
                        <div style={{display: 'inline'}}>
                            <img src="imgs/2.png" width="15px" height="14x" className="link"  onClick={() => document.location = 'mailto:kfireven@gmail.com'}/>
                        </div>
                        <a href="https://www.facebook.com/kfireven" target="_blank" style={{display: 'flex', whiteSpace: 'nowrap'}}>&nbsp; Facebook</a>
                    </div>
                </div>
            </div>
            <div className="gameBoxContianer">
                {data.map((value, index) => {
                    return <GameInfoBox
                        key={index}
                        title={value.title}
                        images4urls={value.images4urls}
                        platform={value.platform}
                        description={value.description}
                        downloadUrl={value.downloadUrl}/>
                })}
            </div>
        </div>
    )
}

export default Main;